


























































































import { Vue, Component } from 'vue-property-decorator';
@Component({
    name: 'preface'
})

export default class Preface extends Vue
{

    nurseSpeech: boolean = false;
    nurseHelpAvailable: boolean = false;
    tutorial: boolean = this.$store.state.global.tutorial;
    popup: boolean = false;
    board: boolean = false;

    toggleTutorial()
    {
        this.$store.commit('toggleTutorial');
        this.tutorial = this.$store.state.global.tutorial;
        this.popup = true;
        //this.nursePreamble();
        // this.board = true;
    }

    togglePopup()
    {
        this.popup = false;
        this.$router.push('doors');
    }

    get volume()
    {
        return this.$store.state.global.soundValue;
    }
    set volume(value)
    {
        this.$store.commit('setVolume', value/100);
    }

    changeVolume(event: any)
    {
        this.$store.commit('setVolume', event.target.value/100);
    }
    toggleSound()
    {
        this.$store.commit('toggleSound');
    }

    nursePreamble()
    {
        setTimeout(() =>
        {
            this.nurseHelpAvailable = true;
            this.nurseSpeech = true;
        }
        , 500);

        setTimeout(() =>
        {
            this.$router.push('doors');
        }
        , 8000);
    }

    boardClose()
    {
        this.board = false;
        this.nursePreamble();
    }
}
